import React from 'react';
import PropTypes from 'prop-types';
import EzFormControl from 'wobi-web-common/dist/components/EzFormControl';
import DatePicker from 'wobi-web-common/dist/components/Datepicker';
import {makeStyles} from 'tss-react/mui';
import {useIntl} from 'react-intl';

let isUseRidersListInOffersStepStyle;
const handleIsRidersListInOffersStep = (shouldUseRidersListStyle) => {
  if (!shouldUseRidersListStyle) {
    return {};
  }

  return {
    width: '90%',
    flexWrap: 'wrap',
    marginLeft: 0,
    marginRight: 0,
  };
};

const useStyles = makeStyles()((theme) => ({
  policyDaysDifference: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapper: {

    // change the text color to white in div
    color: theme.palette.text.primary,
    marginTop: 4,
    alignItems: 'center',
    '& .MuiTextField-root>.MuiFormLabel-root': {
      backgroundColor: theme.palette.background.paper,
    },
    '& > .MuiFormControl-root': {
      justifyContent: 'space-evenly',
      width: '100%',

      '&:last-of-type': {
        marginLeft: 20,
        [theme.breakpoints.down(1280)]: {marginLeft: 0},
      },
      [theme.breakpoints.down(1280)]: {
        maxWidth: '14rem',
      },

      // [theme.breakpoints.down(1160)]: { maxWidth: 256 },
    },
    [theme.breakpoints.down(1280)]: {
      // flexDirection: 'column',
    },
    [theme.breakpoints.down(940)]: {
      flexDirection: 'column',

      // justifyContent: 'space-between'
    },

    // if bigger than 1280px, set flexDirection to row
    [theme.breakpoints.up(1280)]: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      width: '80%',
    },
    ...handleIsRidersListInOffersStep(isUseRidersListInOffersStepStyle),

    // [theme.breakpoints.down(1160)]: { width: 256 },
  },
}));

const DateRangePicker = ({
  startDateValue,
  endDateValue,
  minStartDate,
  maxStartDate,
  maxEndDate,
  onStartChange,
  onEndChange,
  startLabel,
  endLabel,
  daysDifference,
  hideDatePicker,
  startError,
  endError,
  isRidersListInOffersStep = false,
}) => {
  isUseRidersListInOffersStepStyle = isRidersListInOffersStep;
  const { classes } = useStyles();
  const intl = useIntl();
  if (hideDatePicker) {
    return null;
  }
  return (
    <div className={classes.wrapper}>
      <EzFormControl
        name='policyStartDate'
        label={intl.formatMessage({id: startLabel})}
        isLabelInChild
        error={Boolean(startError)}
        style={{position: 'relative'}}
        fullWidth={false}
      >
        <DatePicker
          style={{width: '100%'}}
          value={startDateValue}
          minDate={minStartDate}
          maxDate={maxStartDate}
          maxDateMessage=''
          minDateMessage=''
          onChange={onStartChange}
          onAccept={() => {}}
          openTo='date'
          invalidDateMessage=''
          autoOk
          id='policyStartDate'
          variant='inline'
          data-testid='date-picker-start'
          error={Boolean(startError)}
        />

      </EzFormControl>

      <EzFormControl
        name='policyEndDate'
        label={intl.formatMessage({id: endLabel})}
        isLabelInChild
        error={Boolean(endError)}
        style={{position: 'relative'}}
      >
        <DatePicker
          style={{width: '100%'}}
          value={endDateValue}
          minDate={startDateValue}
          maxDate={maxEndDate}
          maxDateMessage=''
          minDateMessage=''
          onChange={onEndChange}
          onAccept={() => {}}
          openTo='date'
          invalidDateMessage=''
          autoOk
          id='policyEndDate'
          variant='inline'
          data-testid='date-picker-end'
          error={Boolean(endError)}
        />

      </EzFormControl>
      {daysDifference && (
        <div style={{width: '50%',
          height: '100%',
          textAlign: 'center'}}>
          {daysDifference}
        </div>
      )}
    </div>
  );
};

DateRangePicker.propTypes = {
  startDateValue: PropTypes.string,
  endDateValue: PropTypes.string,
  minStartDate: PropTypes.string,
  maxStartDate: PropTypes.string,
  maxEndDate: PropTypes.string,
  onStartChange: PropTypes.func.isRequired,
  onEndChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  startError: PropTypes.string,
  endError: PropTypes.string,
  startLabel: PropTypes.string.isRequired,
  endLabel: PropTypes.string.isRequired,
  daysDifference: PropTypes.string,
  hideDatePicker: PropTypes.bool,
};

export default DateRangePicker;
